import React from 'react';

const TestFollowUpButton = () => {
  const testNotification = () => {
    console.log('[TEST] Testing notification...');
    
    // Test browser notification
    if ('Notification' in window) {
      console.log('[TEST] Notification permission:', Notification.permission);
      
      if (Notification.permission === 'granted') {
        new Notification('Test Follow-up Reminder', {
          body: 'This is a test notification',
          icon: '/favicon.ico',
        });
        console.log('[TEST] ✅ Notification sent');
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then(permission => {
          console.log('[TEST] Permission result:', permission);
          if (permission === 'granted') {
            new Notification('Test Follow-up Reminder', {
              body: 'This is a test notification',
              icon: '/favicon.ico',
            });
            console.log('[TEST] ✅ Notification sent after permission granted');
          }
        });
      } else {
        console.log('[TEST] ❌ Notification permission denied');
        alert('Browser notifications are blocked. Please enable them in browser settings.');
      }
    } else {
      console.log('[TEST] ❌ Browser does not support notifications');
      alert('Your browser does not support notifications');
    }

    // Test sound
    try {
      console.log('[TEST] Playing test sound...');
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.value = 800;
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
      
      setTimeout(() => {
        const oscillator2 = audioContext.createOscillator();
        const gainNode2 = audioContext.createGain();
        
        oscillator2.connect(gainNode2);
        gainNode2.connect(audioContext.destination);
        
        oscillator2.frequency.value = 1000;
        oscillator2.type = 'sine';
        
        gainNode2.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode2.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
        
        oscillator2.start(audioContext.currentTime);
        oscillator2.stop(audioContext.currentTime + 0.5);
        
        console.log('[TEST] ✅ Sound played successfully');
      }, 200);
      
    } catch (error) {
      console.error('[TEST] ❌ Error playing sound:', error);
      alert('Error playing sound: ' + error.message);
    }
  };

  return (
    <button 
      onClick={testNotification}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        padding: '12px 20px',
        backgroundColor: '#667eea',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
        zIndex: 9999,
      }}
    >
      🔔 Test Notification
    </button>
  );
};

export default TestFollowUpButton;
